import React from "react";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import { Button } from "@arctheme-components/elements/Button/Button";

const BannerOverlay = ({ blockItem, section_settings, isMobile }) => {
  return (
    <div
      className={`banner_overlay
            pt-[${blockItem.settings.padding_top_mobile}px]
            lg:pt-[${blockItem.settings.padding_top_desktop}px]
            pb-[${blockItem.settings.padding_bottom_mobile}px]
            lg:pb-[${blockItem.settings.padding_bottom_desktop}px]
            px-[${blockItem.settings.padding_left_right_mobile}px]
            lg:px-[${blockItem.settings.padding_left_right_desktop}px]
            items-${blockItem.settings.content_position_desktop}
            justify-${blockItem.settings.content_position_desktop_hor}`}
    >
      <div
        className={`banner_overlay_content
                w-[${section_settings.mobile_content_width}px]
                ${section_settings.content_width > 0 && `lg:w-[${section_settings.content_width}px]`}
                w-full color-${blockItem.color_schema}
                py-[16px]
                lg:py-[40px]`}
      >
        <div
          className={`banner_overlay__data
                    w-full
                    gap-y-[${blockItem.settings.content_gap_mobile}px]
                    lg:gap-y-[${blockItem.settings.content_gap_desktop}px]
                    lg:w-[${blockItem.settings.content_width_desktop}px]
                    lg:text-${blockItem.settings.content_alignment_desktop}
                    text-${blockItem.settings.content_alignment_mobile}
            `}
          style={{
            gap: isMobile
                ? `${blockItem.settings.content_gap_mobile}px`
                : `${blockItem.settings.content_gap_desktop}px`,
          }}
        >
          {blockItem.settings.tagline && (
            <Paragraph
                text={blockItem.settings.tagline}
                type={"b3"}
            />
          )}
          {blockItem.settings.title && (
            <Paragraph
              text={blockItem.settings.title}
              type={
                isMobile
                  ? blockItem.settings.title_heading_type_mobile
                  : blockItem.settings.title_heading_type
              }
            />
          )}

          {blockItem.settings.subtext && (
            <Paragraph
              text={blockItem.settings.subtext}
              type={`subtext ${blockItem.settings.subtext_type}`}
            />
          )}

          <div className={"banner_overlay_cta"}>
            {blockItem.settings.button_text && (
              <Button
                style={blockItem.settings.button_style}
                icon={blockItem.settings.button_icon}
                label={blockItem.settings.button_text}
                link={blockItem.settings.button_url}
                reverse={blockItem.settings.button_reverse_icon}
                onClick={undefined}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerOverlay;
